export const changeArrayToWeekDay = (arr: never[] | string[] | undefined) => {
  const weekday = [
    "",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];
  let result = [];
  const temArr = arr || [];

  for (let i = 0; i < temArr.length; i++) {
    result.push(weekday[parseInt(temArr[i])]);
  }

  return result.toString();
};

export const workingPeriodStatus = (item: number = 0): string => {
  enum PeriodStatus {
    "temporality",
    "one off",
    "periodic",
  }
  return PeriodStatus[item];
};

export const taskStatus = (item: number = 0): string => {
  enum TaskStatusEum {
    "new job",
    "to be confirmed helper",
    "in progress",
    "completed",
    "cancelled",
  }
  return TaskStatusEum[item];
};

export const helperStatus = (item: number = 0): string => {
  enum HelperStatusEum {
    "enable",
    "deactivated",
  }
  return HelperStatusEum[item];
};

export const employerStatus = (item: number = 0): string => {
  enum EmployerStatusEum {
    "enable",
    "troublemakers",
    "deactivated",
  }
  return EmployerStatusEum[item];
};

export const taskAttendanceStatus = (item: number = 0): string => {
  enum TaskAttendanceEnum {
    "pending",
    "confirmed",
    "sign in",
    "absent",
    "leave",
    "cancel",
  }
  return TaskAttendanceEnum[item];
};

export const gender = (item: number = 0): string => {
  enum GenderEum {
    "male",
    "females",
  }
  return GenderEum[item];
};

export const taskRecord = (item: number = 0): string => {
  enum GenderEum {
    "in progress",
    "complete",
    "cancel",
  }
  return GenderEum[item];
};

export const creditDebitType = (item: number = 0): string => {
  enum NoteTypeEum {
    "Credit Note",
    "Debit Note",
  }
  return NoteTypeEum[item];
};

export const invoiceRecordStatus = (item: number = 0): string => {
  enum InvoiceStatusEum {
    "non payment",
    "paid",
    "expired",
    "cancelled",
  }
  return InvoiceStatusEum[item];
};

export const paymentMethod = (item: number = 0): string => {
  enum PaymentMethodEum {
    "cheque",
    "bank transfer",
    "FPS",
    "WeChat pay",
    "Ali pay",
    "cash",
  }
  return PaymentMethodEum[item];
};

export const paymentMethodEng = (item: number = 0): string => {
  enum PaymentMethodEum {
    "Cheque",
    "Bank Payment",
    "FPS",
    "WeChat pay",
    "Ali pay",
  }
  return PaymentMethodEum[item];
};

export const paymentStatus = (item: number = 0): string => {
  enum PaymentStatusEum {
    "unpaid",
    "paid",
  }
  return PaymentStatusEum[item];
};

export const languages = (item: string = ""): string => {
  if (!item) {
    return '';
  }

  const formatLanguage = (lang: string): string => {
    switch (lang) {
      case "cantonese":
        return "cantonese";
      case "english":
        return "english";
      case "putonghua":
        return "mandarin";
      // case "潮洲話":
      //   return "潮洲話";
      // case "上海話":
      //   return "上海話";
      // case "福建話":
      //   return "福建話";
      // case "客家話":
      //   return "客家話";
      default:
        return "";
    }
  };

  let tempLanguageArray = item.split(",");
  let formattedLanguageArray = [];

  for (const language of tempLanguageArray) {
    formattedLanguageArray.push(formatLanguage(language));
  }

  return formattedLanguageArray.toString();
};

export const timeTableDisplay = (timeTable: { monAm: boolean }): string => {
  const formatTime = (key: string): string => {
    switch (key) {
      case "monAm":
        return "Monday AM";
      case "monPm":
        return "Monday PM";
      case "tueAm":
        return "Tuesday AM";
      case "tuePm":
        return "Tuesday PM";
      case "wedAm":
        return "Wednesday AM";
      case "wedPm":
        return "Wednesday PM";
      case "thuAm":
        return "Thursday AM";
      case "thuPm":
        return "Thursday PM";
      case "friAm":
        return "Friday AM";
      case "friPm":
        return "Friday PM";
      case "satAm":
        return "Saturday AM";
      case "satPm":
        return "Saturday PM";
      case "sunAm":
        return "Sunday AM";
      case "sunPm":
        return "Sunday PM";
      default:
        return "";
    }
  };

  // let formattedTimeTableArray = [];
  // let tempTimeArray = [];

  // for (const [key, value] of Object.entries(timeTable)) {

  // }

  // for (const time of tempTimeArray) {
  //   formattedTimeTableArray.push(formatTime(time));
  // }

  // return formattedTimeTableArray.toString();
  return "";
};

export const formatTimeTable = (timeTable: string[]) => {
  // const timeArray = ["monAm", "monPm", "tueAm", "tuePm", "wedAm", "wedPm", "thuAm", "thuPm", "friAm", "friPm", "satAm", "satPm", "sunAm", "sunPm"];
  let newTimeTable: {
    [key: string]: boolean;
  } = {
    monAm: false,
    monPm: false,
    tueAm: false,
    tuePm: false,
    wedAm: false,
    wedPm: false,
    thuAm: false,
    thuPm: false,
    friAm: false,
    friPm: false,
    satAm: false,
    satPm: false,
    sunAm: false,
    sunPm: false,
  };
  for (const time of timeTable) {
    newTimeTable[time] = true;
  }

  return newTimeTable;
};
